const {
  getRequest,
  getDetailRequest,
  patchRequest,
  deleteRequest,
} = require("./axiosRequest");

const url = `${process.env.REACT_APP_SERVER_URI}/api/v1/record`;

export const getRecord = (param) => getRequest(url, param);
export const getRecordCount = (param) => getRequest(`${url}/count`, param);
export const getRecordStat = (param) => getRequest(`${url}/statistic`, param);
export const getRecordComparison = (param) =>
  getRequest(`${url}/comparison`, param);
export const getRecordDetail = (param) => getDetailRequest(url, param);
export const patchRecord = (body) => patchRequest(url, body);
export const deleteRecord = (body) => deleteRequest(url, body);
export const getRecordReviewedRatio = (param) =>
  getRequest(`${url}/reviewed-ratio`, param);
// export const postPatient = (body) => postRequest(url, body);
